import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Controller, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EmailAction, EmailRecipient } from '../../../../../../../enums/email';
import { FormValues } from '../../CreateEditDialog.functions';

type Props = {
  emailAction: EmailAction;
  emailRecipient: EmailRecipient;
};

function Fields({ emailAction, emailRecipient }: Props): JSX.Element {
  const { t } = useTranslation();

  const { fields, remove } = useFieldArray<FormValues>({
    name: `email_configuration[${emailAction}][${emailRecipient}]`,
  });

  return (
    <>
      {fields.length ? (
        fields?.map((fields: any, index: number) => (
          <div
            className="p-mb-2 p-fluid p-d-flex p-ai-baseline"
            key={fields.id}
          >
            <span style={{ width: 35 }}>{`${index + 1}.`}</span>

            <Controller
              name={`email_configuration[${emailAction}][${emailRecipient}][${index}]`}
              render={({ field }) => (
                <InputText
                  id={`email_configuration[${emailAction}][${emailRecipient}][${index}]`}
                  //  name={`email_configuration[${emailAction}][${emailRecipient}][${index}]`}
                  value={field.value}
                  onChange={field.onChange}
                  className="p-mx-2"
                />
              )}
            />

            <Button
              type="button"
              icon="fas fa-trash"
              onClick={() => remove(index)}
              className="p-button-secondary p-button-text"
            />
          </div>
        ))
      ) : (
        <p>
          <i>{t('No emails are added yet.')}</i>
        </p>
      )}
    </>
  );
}

export default Fields;
